import { render, staticRenderFns } from "./AttachmentDetail.vue?vue&type=template&id=55e0be58&scoped=true&"
import script from "./AttachmentDetail.vue?vue&type=script&lang=js&"
export * from "./AttachmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentDetail.vue?vue&type=style&index=0&id=55e0be58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e0be58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e0be58')) {
      api.createRecord('55e0be58', component.options)
    } else {
      api.reload('55e0be58', component.options)
    }
    module.hot.accept("./AttachmentDetail.vue?vue&type=template&id=55e0be58&scoped=true&", function () {
      api.rerender('55e0be58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/library/AttachmentDetail.vue"
export default component.exports